export default __webpack_public_path__ + "media/images/acca-logo-7299b17811968b9394ce1db0e75aeb5b.svg";